// C-01a's "PF message" row (task 24, D-81): the PF internal message about this booking.
import type { AppointmentRow } from '@pa/api/clinic'
import { fmtDateTimeOf } from '@pa/ui'

export const PF_MESSAGE_ROW = 'PF message'

export const PF_MESSAGE_STATUS_COPY = {
  sent: (at: string) => `Sent · ${at}`,
  pending: 'Pending (retrying)',
  failed: 'Failed after retry',
  skipped: 'Not sent (turned off)',
}

/** The row's text; `failed` gets " · see Errors" (a link) from the drawer. `sending` reads as pending. */
export function pfMessageLabel(m: NonNullable<AppointmentRow['pfMessage']>, timeZone: string): string {
  switch (m.status) {
    case 'sent':
      return PF_MESSAGE_STATUS_COPY.sent(m.sentAt ? fmtDateTimeOf(m.sentAt, timeZone) : '')
    case 'pending':
    case 'sending':
      return PF_MESSAGE_STATUS_COPY.pending
    case 'failed':
      return PF_MESSAGE_STATUS_COPY.failed
    case 'skipped':
      return PF_MESSAGE_STATUS_COPY.skipped
  }
}

/**
 * C-01's short status under the PF appointment ID (2026-10-16). The same states as the drawer's row (`sending` reads
 * as pending); the drawer's full words are its tooltip.
 */
export const PF_MESSAGE_SHORT_COPY = {
  sent: 'Message sent',
  pending: 'Message pending',
  failed: 'Message failed',
  skipped: 'Message not sent',
}

/** The status dot's colour: green sent, amber pending, red failed, grey not sent (the `state-dot` classes). */
export type PfMessageTone = 'ok' | 'warn' | 'down' | 'idle'

export function pfMessageShort(m: NonNullable<AppointmentRow['pfMessage']>): { text: string; tone: PfMessageTone } {
  switch (m.status) {
    case 'sent':
      return { text: PF_MESSAGE_SHORT_COPY.sent, tone: 'ok' }
    case 'pending':
    case 'sending':
      return { text: PF_MESSAGE_SHORT_COPY.pending, tone: 'warn' }
    case 'failed':
      return { text: PF_MESSAGE_SHORT_COPY.failed, tone: 'down' }
    case 'skipped':
      return { text: PF_MESSAGE_SHORT_COPY.skipped, tone: 'idle' }
  }
}
